import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, createSlots as _createSlots } from "vue"

const _hoisted_1 = { key: 1 }
const _hoisted_2 = { class: "margin-r-half" }
const _hoisted_3 = { class: "list-unstyled" }
const _hoisted_4 = ["for"]
const _hoisted_5 = { key: 2 }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { class: "margin-r-half" }
const _hoisted_8 = { key: 1 }
const _hoisted_9 = { class: "margin-r-half" }
const _hoisted_10 = { class: "list-disk" }
const _hoisted_11 = { key: 2 }

import { computed, PropType } from "vue";

import { ContentStructureSection } from "@/models/content-structure.model";
import {
  ContentTemplate,
  MetadataAllowedValues,
  MetadataDefinitionItem
} from "@/models/content-templates.model";
import { MetadataInstance } from "@/models/product-section.model";
import { ProductItem } from "@/models/product.model";

import {
  getMetadataInstance,
  isMetadataValueChecked
} from "@/utils/content-metadata-helpers";

import MultipleOption from "@/components/right-sidebars/content-sidebar/content-metadata/MultipleOption.vue";
import SingleOption from "@/components/right-sidebars/content-sidebar/content-metadata/SingleOption.vue";
import TextFree from "@/components/right-sidebars/content-sidebar/content-metadata/TextFree.vue";

import Collapse from "../../ui/Collapse.vue";

interface MetadataCheckedValue {
  id: number;
  name: string;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'ContentMetadata',
  props: {
  product: {
    required: true,
    type: Object as PropType<ProductItem>
  },
  section: {
    required: true,
    type: Object as PropType<ContentStructureSection>
  },
  canEditContent: {
    required: true,
    type: Boolean
  },
  displayedMetadata: {
    required: true,
    type: Array as PropType<MetadataInstance[]>
  },
  isUpdating: {
    required: true,
    type: Boolean
  }
},
  setup(__props) {

const props = __props;

const template = computed<ContentTemplate | undefined>(() => {
  if (!props.product) {
    return undefined;
  }
  return props.product.component_definitions.find(
    (e: ContentTemplate): boolean => e.id === props.section.type.id
  );
});

const getMetadataAllowedValues = (id: number): MetadataAllowedValues[] => {
  if (template.value) {
    const metadataDefinition: MetadataDefinitionItem | undefined =
      template.value.metadata_definition.find(
        (e: MetadataDefinitionItem): boolean => e.id === id
      );
    return metadataDefinition ? metadataDefinition.metadata_allowed_values : [];
  }
  return [];
};

const getMetadataCheckedValues = (
  instanceId: number
): MetadataCheckedValue[] => {
  const instance: MetadataInstance | undefined = getMetadataInstance(
    props.section.metadata_instances,
    instanceId
  );
  if (instance) {
    const allowedValues: MetadataAllowedValues[] = getMetadataAllowedValues(
      instance.metadata_definition.id
    );
    return allowedValues
      .filter((value: MetadataAllowedValues): boolean =>
        isMetadataValueChecked(instance, value.id)
      )
      .map((value: MetadataAllowedValues): MetadataCheckedValue => {
        return {
          id: value.id,
          name: value.display_name
        };
      });
  }
  return [];
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(Collapse, {
    class: _normalizeClass({ updating: __props.isUpdating })
  }, _createSlots({
    title: _withCtx(() => [
      _cache[0] || (_cache[0] = _createTextVNode(" Metadata ", -1))
    ]),
    _: 2
  }, [
    (__props.canEditContent)
      ? {
          name: "content",
          fn: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.section.metadata_instances, (item, index) => {
              return (_openBlock(), _createElementBlock("div", {
                key: item.id
              }, [
                (item.metadata_definition.type === 'Text Free')
                  ? (_openBlock(), _createBlock(TextFree, {
                      key: 0,
                      item: item,
                      "product-id": __props.product.id
                    }, null, 8, ["item", "product-id"]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_1, [
                      _createElementVNode("strong", _hoisted_2, [
                        _createTextVNode(_toDisplayString(item.metadata_definition.name) + " ", 1),
                        _createElementVNode("small", null, "(select " + _toDisplayString(item.metadata_definition.type === "Single Option"
                  ? "one"
                  : "multiple") + ") ", 1)
                      ]),
                      _createElementVNode("ul", _hoisted_3, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(getMetadataAllowedValues(
                item.metadata_definition.id
              ), (value) => {
                          return (_openBlock(), _createElementBlock("li", {
                            key: value.id
                          }, [
                            _createElementVNode("label", {
                              for: value.id
                            }, [
                              (item.metadata_definition.type === 'Single Option')
                                ? (_openBlock(), _createBlock(SingleOption, {
                                    key: 0,
                                    "current-instance": item,
                                    instances: __props.section.metadata_instances,
                                    "product-id": __props.product.id,
                                    value: value
                                  }, null, 8, ["current-instance", "instances", "product-id", "value"]))
                                : _createCommentVNode("", true),
                              (item.metadata_definition.type === 'Multiple Options')
                                ? (_openBlock(), _createBlock(MultipleOption, {
                                    key: 1,
                                    "current-instance": item,
                                    instances: __props.section.metadata_instances,
                                    "product-id": __props.product.id,
                                    value: value
                                  }, null, 8, ["current-instance", "instances", "product-id", "value"]))
                                : _createCommentVNode("", true),
                              _createTextVNode(" " + _toDisplayString(value.display_name), 1)
                            ], 8, _hoisted_4)
                          ]))
                        }), 128))
                      ])
                    ])),
                (index < __props.section.metadata_instances.length - 1)
                  ? (_openBlock(), _createElementBlock("hr", _hoisted_5))
                  : _createCommentVNode("", true)
              ]))
            }), 128))
          ]),
          key: "0"
        }
      : {
          name: "content",
          fn: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.displayedMetadata, (item, index) => {
              return (_openBlock(), _createElementBlock("div", {
                key: item.id
              }, [
                (item.metadata_definition.type === 'Text Free')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                      _createElementVNode("strong", _hoisted_7, _toDisplayString(item.metadata_definition.name) + ":", 1),
                      _createElementVNode("span", null, _toDisplayString(item.authored_text), 1)
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_8, [
                      _createElementVNode("strong", _hoisted_9, _toDisplayString(item.metadata_definition.name), 1),
                      _createElementVNode("ul", _hoisted_10, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(getMetadataCheckedValues(item.id), (value) => {
                          return (_openBlock(), _createElementBlock("li", {
                            key: value.id
                          }, [
                            _createElementVNode("span", null, _toDisplayString(value.name), 1)
                          ]))
                        }), 128))
                      ])
                    ])),
                (index < __props.displayedMetadata.length - 1)
                  ? (_openBlock(), _createElementBlock("hr", _hoisted_11))
                  : _createCommentVNode("", true)
              ]))
            }), 128))
          ]),
          key: "1"
        }
  ]), 1032, ["class"]))
}
}

})